import { useLocation } from 'react-router'

function useQueryParams(key: string) {
  const query = new URLSearchParams(useLocation().search)

  return query.get(key)
}

export default useQueryParams
